import { render, staticRenderFns } from "./ZlAssess.vue?vue&type=template&id=ca049dce&scoped=true"
import script from "./ZlAssess.vue?vue&type=script&lang=js"
export * from "./ZlAssess.vue?vue&type=script&lang=js"
import style0 from "./ZlAssess.vue?vue&type=style&index=0&id=ca049dce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca049dce",
  null
  
)

export default component.exports